import { notification } from "antd";

export const openNotificationSuccess = (description, duration) => {
  notification.success({
    message: "Success",
    description: description,
    placement: "topRight",
    duration: duration ?? 5, // Use nullish coalescing to allow 0
  });
};
// Notification error handler
export const openNotificationError = (message ,error) => {
  notification.error({
    message: message,
    description: error?.response?.data?.message || '',
    placement: "topRight", // Positioning at top-right
  });
};
